import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const InformationSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99967 14.6668C4.31767 14.6668 1.33301 11.6822 1.33301 8.00016C1.33301 4.31816 4.31767 1.3335 7.99967 1.3335C11.6817 1.3335 14.6663 4.31816
      14.6663 8.00016C14.6663 11.6822 11.6817 14.6668 7.99967 14.6668ZM7.99967 13.3335C9.41416 13.3335 10.7707 12.7716 11.7709 11.7714C12.7711 10.7712 13.333
      9.41465 13.333 8.00016C13.333 6.58567 12.7711 5.22912 11.7709 4.22893C10.7707 3.22873 9.41416 2.66683 7.99967 2.66683C6.58519 2.66683 5.22863 3.22873
      4.22844 4.22893C3.22824 5.22912 2.66634 6.58567 2.66634 8.00016C2.66634 9.41465 3.22824 10.7712 4.22844 11.7714C5.22863 12.7716 6.58519 13.3335 7.99967
      13.3335ZM7.33301 5.3335C7.33301 4.96531 7.63148 4.66683 7.99967 4.66683C8.36786 4.66683 8.66634 4.96531 8.66634 5.3335C8.66634 5.70169 8.36786 6.00016
      7.99967 6.00016C7.63148 6.00016 7.33301 5.70169 7.33301 5.3335ZM7.33301 8.00016C7.33301 7.63197 7.63148 7.3335 7.99967 7.3335C8.36786 7.3335 8.66634
      7.63197 8.66634 8.00016V10.6668C8.66634 11.035 8.36786 11.3335 7.99967 11.3335C7.63148 11.3335 7.33301 11.035 7.33301 10.6668V8.00016Z"
      fill="#0E0E0E"
    />
  </svg>
);

const Information = (props: IIconProps) => <Icon component={InformationSvg} {...props} />;

export default Information;
